<template>
  <!--  -->
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-16 shadow-lg items-center">
    <!--  -->
    <div class="bg-white w-fullrounded-lg shadow">
      <!--  -->
      <div class="h-20 py-3 flex items-center border-gray-300 p-6 mt-5">
        <!--  -->
        <div class="flex">
          <!--  -->
          <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()">
            <!--  -->
            <i class="material-icons">chevron_left</i>
            <!--  -->
          </button>
          <!--  -->

          <!--  -->
          <div v-if="!formData._id" class="text-2xl font-bold text-primary-500">
            {{ $t('new_group') }}
          </div>
          <!--  -->

          <!--  -->
          <div v-else class="text-2xl font-bold text-primary-500">
            {{ $t('edit_group') }}
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="relative">
        <!--  -->

        <!--  -->
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <!--  -->

        <!--  -->
        <div class="bg-white rounded-lg p-6">
          <!--  -->
          <div class="grid lg:grid-cols-2 gap-6">
            <!--  -->
            <div
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="fullName" class="bg-white text-gray-700 px-1">{{ $t('full_name') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="fullName" autocomplete="false" tabindex="0" type="text" v-model="formData.fullName"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="formData._id"
              class="border-2 border-orange-700 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="phone" class="bg-white text-gray-700 px-1">{{ $t('phone') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="phone" autocomplete="false" tabindex="0" type="text" v-model="formData.phone"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="username" class="bg-white text-gray-700 px-1">{{ $t('username') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="username" autocomplete="false" tabindex="0" type="text" v-model="formData.username"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                  @keydown.space="event => event.preventDefault()" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="email" class="bg-white text-gray-700 px-1">{{ $t('email') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input autocomplete="false" tabindex="0" type="email" :disabled="formData._id" v-model="formData.email"
                  class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border h-10 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="name" class="bg-white text-gray-700 px-1">{{ $t('role') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <v-select label="name" @input="onChangeRole(formData.role)" @search="searchRoles($event, 'hh')"
                  v-model="formData.role" :options="roles"></v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border seller-select h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="Countries" class="bg-white text-gray-700 px-1">
                    {{ $t('countries') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <v-select label="countryName" @input="setSelectedCountries" v-model="formData.countries"
                  :options="warehouses" multiple>
                  <!--  -->
                  <template slot="option" slot-scope="option">
                    <!--  -->
                    <img class="flag-img" :src="$f.getCountryCode(option.country)" />
                    <!--  -->
                    {{ option.countryName }}
                  </template>
                  <!--  -->
                </v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->


            <!--  -->
            <div v-if="!formData._id" class="flex items-center justify-between">
              <!--  -->
              <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
              <!--  -->
              <span @click="CreateNewRole"
                class="text-xs text-primary-500 font-bold cursor-pointer uppercase dark:text-primary-400 hover:underline">{{
                  $t('create_new_role') }}
              </span>
              <!--  -->
              <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="mt-20 pt-3 pb-4 flex justify-center">
            <!--  -->
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              @click="save">
              {{ $t('save') }}
            </button>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      formData: {
        fullName: '',
        username: '',
        phone: '',
        address: '',
        status: 'inactive',
        type: 'SubUser',
        email: '',
        role: null,
        countries: [],
      },
      roles: [],
      roleFormData: '',
      warehouses: [],
      options: this.$countries,
      selectedRole: '',
      loading: false,
      fullPage: false,
      idWarehouse: null,
      currentUser: {
        role: {},
      },
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    warhouseSelected: {
      immediate: true,
      async handler() {
        await this.getwharhouseId();
        await this.dataToEdit();
      },
    },
  },
  async mounted() {
    await Promise.all([
      this.fetchUser(),
      this.getwharhouseId(),
      this.getRoles(),
      this.getWarehouses(),
    ]);

    await this.dataToEdit();
    this.getDtaStorage();

    if (this.formData._id) {
      this.formData.role = this.roleFormData;
    }
  },
  methods: {
    RouterBack() {
      this.$router.back();
    },
    async getwharhouseId() {
      try {
        const warehouseId = await this.$store.dispatch('wharhouse/getwharhouseId');
        this.idWarehouse = warehouseId;
      } catch (error) {
        console.error('Failed to fetch warehouse ID:', error);
      }
    },
    async getWarehouses() {
      try {
        const filter = { limit: 1000, is_primary: true };
        const { content } = await this.$server.search('warehouses', filter);

        this.warehouses = content.results || [];
      } catch (error) {
        console.error('Failed to fetch warehouses:', error);
        this.warehouses = [];
      }
    },
    async setSelectedCountries(countries) {
      if (!countries) return;

      this.formData.countries = this.formData.countries.map((part) =>
        typeof part === 'object' && part !== null ? part.countryName : part
      );

      this.formData.countries = [...new Set(this.formData.countries)];
    },
    async fetchUser() {
      try {
        const { content } = await this.$server.me('users');
        this.currentUser = content || {};
      } catch (error) {
        console.error('Failed to fetch user:', error);
        this.currentUser = {};
      }
    },
    async getRoles() {
      try {
        const { content } = await this.$server.search('roles', { limit: 1000 });
        this.roles = content.results || [];
      } catch (error) {
        console.error('Failed to fetch roles:', error);
        this.roles = [];
      }
    },
    async onChangeRole(data) {
      if (data && data._id && !this.formData._id) {
        this.formData.type = data.type || '';
        this.selectedRole = data._id;
      }
    },
    searchRoles: _.debounce(async function(search) {
      try {
        const filter = {
          limit: this.limit,
          name: search,
        };
        const { content } = await this.$server.find('roles', filter);

        this.roles = content.results || [];
      } catch (error) {
        console.error('Failed to search roles:', error);
        this.roles = [];
      }
    }, 500),
    CreateNewRole() {
      const { email, username, fullName } = this.formData;

      localStorage.setItem('User_email', email);
      localStorage.setItem('User_username', username);
      localStorage.setItem('User_fullName', fullName);

      this.$router.push('/roles/new');
    },
    DeleteDtaStorage() {
      const itemsToRemove = [
        'Role',
        'User_email',
        'User_username',
        'User_fullName',
      ];

      itemsToRemove.forEach((item) => localStorage.removeItem(item));
    },
    async dataToEdit() {
      if (!this.$route.params.id) return;

      try {
        this.loading = true;

        const { content } = await this.$server.get('groups', {
          id: this.$route.params.id,
        });

        this.formData = content;
        this.roleFormData = content.role;
        this.selectedRole = content.role._id;

        this.ConvertArrayToCountyName(content.countries);
      } catch (error) {
        console.error('Failed to fetch edit data:', error);
      } finally {
        this.loading = false;
      }
    },
    ConvertArrayToCountyName(data) {
      data.forEach((part, index, theArray) => {
        if (part.length === 2) {
          theArray[index] = this.$f.getCountryNameByCode(this.options, part);
        }
      });
    },
    async save() {
      try {
        if (this.formData._id) {
          this.ConvertArrayToCountyCode(this.formData.countries);
          this.formData.email = this.formData.email.toLowerCase().trim();

          if (this.formData.countries.length === 0) {
            alert('Countries required', 'warning');
            return false;
          }

          const { content } = await this.$server.update('groups', this.formData);

          if (content._id) {
            alert(this.$t('group_updated'), 'success');
          } else {
            alert(content || 'Update failed', 'warning');
          }
          return;
        }

        if (!this.formData.role && this.formData.type === '') {
          alert(this.$t('role_required'), 'warning');
          return;
        }

        if (
          !localStorage.getItem('Role_id') &&
          !localStorage.getItem('User_email')
        ) {
          this.formData.type = this.formData.role.type;
        }

        if (!this.checkData()) {
          alert(this.$t('all_required_field'), 'warning');
          return;
        }

        if (this.formData.username.length < 3) {
          alert(this.$t('username_not_valid'), 'warning');
          return;
        }

        this.formData.email = this.formData.email.toLowerCase().trim();
        const { content: checkUserContent } = await this.$server.find('groups', {
          name: this.formData.email,
        });

        if (checkUserContent.results && checkUserContent.results.length > 0) {
          alert(this.$t('email_exist'), 'warning');
          return;
        }

        this.ConvertArrayToCountyCode(this.formData.countries);
        const { content: createUserContent } = await this.$server.create(
          'groups',
          this.formData,
        );

        if(createUserContent.status == 400) {
          alert(this.$t('group_created'), 'success');
        }

        if (createUserContent._id) {
          alert(this.$t('group_created'), 'success');
          this.DeleteDtaStorage();
          this.resetFormData();
        } else {
          alert(createUserContent, 'warning');
        }
      } catch (error) {
        console.error('Failed to save user:', error);
        alert('An error occurred while saving the user', 'error');
      }
    },
    resetFormData() {
      this.formData = {
        fullName: '',
        username: '',
        phone: '',
        address: '',
        status: 'inactive',
        type: 'SubUser',
        email: '',
        role: null,
        countries: [],
      };
    },
    ConvertArrayToCountyCode(data) {
      data.forEach((part, index, theArray) => {
        if (part.length > 2) {
          theArray[index] = this.$f.getCountryCodeByName(this.options, part);
        }
      });
    },
    checkData() {
      return (
        this.formData.countries.length > 0 &&
        this.formData.role &&
        this.formData.email &&
        this.formData.type &&
        this.formData.username &&
        this.formData.fullName
      );
    },
    getDtaStorage() {
      const role = localStorage.getItem('Role');
      const email = localStorage.getItem('User_email');

      if (role && email) {
        const parsedRole = JSON.parse(role);
        this.formData.email = email;
        this.selectedRole = parsedRole;
        this.formData.role = parsedRole;
        this.formData.type = parsedRole.type;

        const username = localStorage.getItem('User_username');
        const fullName = localStorage.getItem('User_fullName');

        if (username) this.formData.username = username;
        if (fullName) this.formData.fullName = fullName;
      }
    }
  },
};
</script>
